import { createContext, PropsWithChildren, useState } from 'react';

import { TradKeys, trads } from '@data/trads';
import { Locales, Trad } from '@types';

export const IntlContext = createContext({
  locale: Locales.FR,
  setLocale: (_locale: Locales) => {},
  translate: (_key: TradKeys) => '' as string,
  translateTrad: (_trad: string | Trad) => '' as string,
});

const STORAGE_KEY = 'locale';
const storageLocale = localStorage.getItem(STORAGE_KEY) as Locales;
const browserLocale = navigator.language.startsWith('fr')
  ? Locales.FR
  : Locales.EN;

export const IntlProvider = ({ children }: PropsWithChildren) => {
  const [locale, setStateLocale] = useState(storageLocale || browserLocale);

  const setLocale = (l: Locales) => {
    setStateLocale(l);
    localStorage.setItem(STORAGE_KEY, l);
  };

  const translate = (key: TradKeys) => trads[key][locale] || `${key}.${locale}`;
  const translateTrad = (trad: string | Trad) =>
    (typeof trad === 'string' ? trad : trad[locale]) || '???';

  return (
    <IntlContext.Provider
      value={{ locale, setLocale, translate, translateTrad }}
    >
      {children}
    </IntlContext.Provider>
  );
};
